import GroupFilter from './GroupFilter';

export default GroupFilter;
